import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Platform-agnostic hook for shell navigation logic.
 * Provides navigation utilities including active route detection.
 */
export function useShellNavigation() {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = useCallback(
    (path: string) => {
      if (path === '/home') {
        return location.pathname === '/home';
      }
      return location.pathname.startsWith(path);
    },
    [location.pathname],
  );

  const navigateToLogin = useCallback(
    (showSignup?: boolean) => {
      const currentPath = location.pathname + location.search + location.hash;
      const afterParam = `after=${encodeURIComponent(currentPath)}`;
      const signupParam = showSignup !== undefined ? `&signup=${showSignup}` : '';
      navigate(`/?${afterParam}${signupParam}`);
    },
    [location, navigate],
  );

  return {
    location,
    navigate,
    isActive,
    navigateToLogin,
  };
}
